define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.concat;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/concat.js
// module id = 597
// module chunks = 0